import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccessControlEntryState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: AccessControlEntryState = {
  data: [],
  isLoading: false,
  error: null,
};

const accessControlEntriesSlice = createSlice({
  name: 'accessControlEntries',
  initialState,
  reducers: {
    setAccessControlEntries: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setAccessControlEntriesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setAccessControlEntriesError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setAccessControlEntries, setAccessControlEntriesLoading, setAccessControlEntriesError } =
  accessControlEntriesSlice.actions;

export default accessControlEntriesSlice.reducer;
